import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import "../../Style/NewCompanyStyle.scss";
import "../../Style/NewCompanyFormUnique.scss";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import axios from "axios";
import { ApiLink } from "../../APILink/ApiLink";
import authHeader from "../../Auth/authHeader";
import { errorAlert, handleSuccess } from "../../Components/Alerts";
import { FiscalYearContext } from "../../FiscalYear/FiscalYearContext";
import { getSystemPackage } from "../../GetData/SystemPackage";
import { getSystemModules } from "../../GetData/SystemModules";
import { getSystemLicenseTypes } from "../../GetData/LicenseType";
import { getLicenseStatus } from "../../GetData/LicenseStatus";
import { getLicensePaymentStatus } from "../../GetData/LicensePaymentType";
import { GetSystemRoles } from "../../GetData/SystemRoles";
import LoginUserDetailed from "../../Auth/LoginUserDetailed";
// import {
//   LICENSE_TYPES,
//   PAYMENT_STATUS,
//   LICENSE_STATUS,
// } from "../../OtherData/LicenseData";

export default function NewCompanyForm() {
  const headers = authHeader();
  const loginEmail = LoginUserDetailed();
  const history = useHistory();
  const location = useLocation();
  const params = useParams();
  const year = new Date().getFullYear();
  const { fiscalYear } = useContext(FiscalYearContext);
  const routeCompanyId = Number(
    params?.companyId || location.state?.companyId || 0
  );
  const isEditMode = Boolean(routeCompanyId) || location.state?.mode === "edit";
  const [disableForm, setDisableForm] = useState(false);
  const [step, setStep] = useState(1);
  const [loading, setLoading] = useState(false);
  const [editDataLoading, setEditDataLoading] = useState(false);
  // Company states
  const [companyName, setCompanyName] = useState("");
  const [identificationNumber, setIdentificationNumber] = useState("");
  const [vatNumber, setVatNumber] = useState("");
  const [adress, setAdress] = useState("");
  const [cityID, setCityID] = useState("");
  const [stateID, setStateID] = useState();
  const [phoneNumbers, setPhoneNumbers] = useState("");
  const [ediPass, setEdiPass] = useState("");
  const [email, setEmail] = useState("");
  const [comment, setComment] = useState("");
  const [vATDeclarant, setvATDeclarant] = useState(true);
  const [isActive, setIsActive] = useState(true);
  const [arbkPass, setArbkPass] = useState("");
  const [mailPass, setMailPass] = useState("");
  const [smtpClient, setSmtpClient] = useState("");

  // License states
  const [licenseTypeID, setLicenseTypeID] = useState();
  const [packageID, setPackageID] = useState("");
  const [moduleIDs, setModuleIDs] = useState([]);
  const [startDate, setStartDate] = useState(new Date().toISOString().slice(0, 10));
  const [endDate, setEndDate] = useState("");
  const [statusID, setStatusID] = useState("");
  const [paymentStatusID, setPaymentStatusID] = useState("");
  const [licenseComment, setLicenseComment] = useState("");
  const [createdCompanyID, setCreatedCompanyID] = useState(null);

  const [states, setStates] = useState([]);
  const [city, setCity] = useState([]);
  const [pack, setPack] = useState([]);
  const [module, setModule] = useState([]);
  const [accountantUser, setAccountantUser] = useState([]);

  const [licenseTypes, setLicenseTypes] = useState([]);
  const [licensesStatus, setLicensesStatus] = useState([]);
  const [licensePaymentType, setLicensePaymentType] = useState([]);
  const [roles, setRoles] = useState([]);

  const [accountantUserID, setAccountantUserID] = useState("");
  const [ipAddress, setIpAddress] = useState("");
  const [userComment, setUserComment] = useState("");
  const [hasExistingCompanyUser, setHasExistingCompanyUser] = useState(false);
  const [hasExistingLicense, setHasExistingLicense] = useState(false);
  const [hasExistingAccountant, setHasExistingAccountant] = useState(false);

  const [newUserEmail, setNewUserEmail] = useState("");
  const [newUserPassword, setNewUserPassword] = useState("");
  const [newUserRole, setNewUserRole] = useState("");
  const [editingCompanyUserId, setEditingCompanyUserId] = useState("");
  const [activeCompanyUsers, setActiveCompanyUsers] = useState([]);
  const [companyUsersLoading, setCompanyUsersLoading] = useState(false);
  const [companyMenuTree, setCompanyMenuTree] = useState([]);
  const [menuVisibilityLoading, setMenuVisibilityLoading] = useState(false);
  const [menuVisibilitySavingId, setMenuVisibilitySavingId] = useState(null);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [expandedPanels, setExpandedPanels] = useState(() => ({
    1: !isEditMode,
    2: false,
    3: false,
    4: false,
    5: false,
    6: false,
  }));

  const getApiErrorMessage = (error, fallbackMessage) => {
    if (error?.response) {
      const status = error.response.status;
      const data = error.response.data;

      if (typeof data === "string" && data.trim()) {
        return data;
      }

      if (data?.message && typeof data.message === "string") {
        return data.message;
      }

      if (data?.error && typeof data.error === "string") {
        return data.error;
      }

      if (data?.errors && typeof data.errors === "object") {
        const firstField = Object.keys(data.errors)[0];
        const firstError = firstField ? data.errors[firstField]?.[0] : null;
        if (firstError) {
          return `Gabim validimi: ${firstError}`;
        }
      }

      if (status === 409) {
        return "Kompania ekziston ose ka konflikt me të dhënat ekzistuese.";
      }

      if (status === 400) {
        return "Të dhënat e dërguara nuk janë valide. Kontrolloni fushat e formularit.";
      }

      if (status >= 500) {
        return "Gabim në server. Ju lutem provoni përsëri pas pak.";
      }

      return `Gabim nga serveri (Status: ${status}).`;
    }

    if (error?.request) {
      return "Serveri nuk u përgjigj. Kontrolloni lidhjen me internet ose serverin.";
    }

    if (error?.message) {
      return `Gabim gjatë dërgimit të kërkesës: ${error.message}`;
    }

    return fallbackMessage;
  };

  //Pjesa per select input field users
  const [userName, setUserName] = useState("");
  const handleAutocompleteChangeUser = (event, value) => {
    if (value && value.Id) {
      setAccountantUserID(value.Id);
      setUserName(value);
    } else {
      // Në rast se vlera është pastruar
      setAccountantUserID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsUser = {
    options: accountantUser,
    getOptionLabel: (option) => `${option.UserName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.UserName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field states
  const [stateName, setStateName] = useState("");
  const handleAutocompleteChangeState = (event, value) => {
    if (value && value.StateID) {
      setCityID("");
      setCityName("");
      setStateID(value.StateID);
      setStateName(value);
      fetchCityByState(value.StateID);
    } else {
      // Në rast se vlera është pastruar
      setStateID(""); // Vendos vlerën e ArticleID në null
      setCityID("");
      setCityName("");
      setCity([]);
    }
  };

  const defaultPropsStates = {
    options: states,
    getOptionLabel: (option) => `${option.StateName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.StateName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  //Pjesa per select input field city
  const [cityName, setCityName] = useState("");
  const handleAutocompleteChangeCity = (event, value) => {
    if (value && value.CityID) {
      setCityID(value.CityID);
      setCityName(value);
    } else {
      // Në rast se vlera është pastruar
      setCityID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsCities = {
    options: city,
    getOptionLabel: (option) => `${option.CityName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.CityName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  // const completeData = (id) => {
  //   if (id === 4) {
  //     setStatusID(4);
  //     setPaymentStatusID(4);
  //   } else if (id === 5) {
  //     setStatusID(5);
  //     setPaymentStatusID(5);
  //   }
  // };

  //Pjesa per select input field licenseType
  const [licenseType, setLiceseType] = useState(null);
  const handleAutocompleteChangeLicenseType = (event, value) => {
    if (value && value.DurationTypeID) {
      setLicenseTypeID(value.DurationTypeID);
      setLiceseType(value);
      // kalkulo endDate automatikisht
      const calculatedEnd = calculateEndDate(value.DurationDays);
      setEndDate(calculatedEnd);
      // completeData(value.DurationTypeID);
    } else {
      // nëse pastrohet
      setLicenseTypeID("");
      setLiceseType(null);
      setEndDate("");
    }
  };

  const defaultPropsLicenseType = {
    options: licenseTypes,
    getOptionLabel: (option) => `${option.DurationName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.DurationName}
            <br />
          </span>
        </li>
      </>
    ),
  };
  // const [licenseType, setLiceseType] = useState("");
  // const handleAutocompleteChangeLicenseType = (event, value) => {
  //   if (value && value.DurationTypeID) {
  //     setLicenseTypeID(value.id);
  //     setLiceseType(value);
  //     // kalkulo endDate automatikisht
  //     const calculatedEnd = calculateEndDate(value.value);
  //     setEndDate(calculatedEnd);
  //     completeData(value.id);
  //   } else {
  //     // nëse pastrohet
  //     setLicenseTypeID("");
  //     setLiceseType(null);
  //     setEndDate("");
  //   }
  // };

  // const defaultPropsLicenseType = {
  //   options: LICENSE_TYPES,
  //   getOptionLabel: (option) => `${option.label}` || "",
  //   renderOption: (props, option) => (
  //     <>
  //       <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //         <span>
  //           {option.label}
  //           <br />
  //         </span>
  //       </li>
  //     </>
  //   ),
  // };

  //Pjesa per select input field licenseStatus
  const [licenseStatus, setLiceseStatus] = useState(null);
  const handleAutocompleteChangeLicenseStatus = (event, value) => {
    if (value && value.LicenseStatusID) {
      setStatusID(value.LicenseStatusID);
      setLiceseStatus(value);
    } else {
      // Në rast se vlera është pastruar
      setStatusID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsLicenseStatus = {
    options: licensesStatus,
    getOptionLabel: (option) => `${option.StatusName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.StatusName}
            <br />
          </span>
        </li>
      </>
    ),
  };
  // const [licenseStatus, setLiceseStatus] = useState("");
  // const handleAutocompleteChangeLicenseStatus = (event, value) => {
  //   if (value && value.id) {
  //     setStatusID(value.id);
  //     setLiceseStatus(value);
  //   } else {
  //     // Në rast se vlera është pastruar
  //     setStatusID(""); // Vendos vlerën e ArticleID në null
  //   }
  // };

  // const defaultPropsLicenseStatus = {
  //   options: LICENSE_STATUS,
  //   getOptionLabel: (option) => `${option.label}` || "",
  //   renderOption: (props, option) => (
  //     <>
  //       <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //         <span>
  //           {option.label}
  //           <br />
  //         </span>
  //       </li>
  //     </>
  //   ),
  // };

  //Pjesa per select input field paymentStatus
  const [paymentStatus, setPaymentStatus] = useState("");
  const handleAutocompleteChangePaymentStatus = (event, value) => {
    if (value && value.PaymentStatusID) {
      setPaymentStatusID(value.PaymentStatusID);
      setPaymentStatus(value);
    } else {
      // Në rast se vlera është pastruar
      setPaymentStatusID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsPaymentStatus = {
    options: licensePaymentType,
    getOptionLabel: (option) => `${option.StatusName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.StatusName}
            <br />
          </span>
        </li>
      </>
    ),
  };
  // const [paymentStatus, setPaymentStatus] = useState("");
  // const handleAutocompleteChangePaymentStatus = (event, value) => {
  //   if (value && value.id) {
  //     setPaymentStatusID(value.id);
  //     setPaymentStatus(value);
  //   } else {
  //     // Në rast se vlera është pastruar
  //     setPaymentStatusID(""); // Vendos vlerën e ArticleID në null
  //   }
  // };

  // const defaultPropsPaymentStatus = {
  //   options: PAYMENT_STATUS,
  //   getOptionLabel: (option) => `${option.label}` || "",
  //   renderOption: (props, option) => (
  //     <>
  //       <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //         <span>
  //           {option.label}
  //           <br />
  //         </span>
  //       </li>
  //     </>
  //   ),
  // };

  //Pjesa per select input field pack
  const [packageType, setPackageType] = useState(null);
  const [packageField, setPackageField] = useState(null);
  const handleAutocompleteChangePackageType = (event, value) => {
    if (value && value.PackageID) {
      setPackageID(value.PackageID);
      setPackageType(value.PackageName);
      setPackageField(value);
    } else {
      // Në rast se vlera është pastruar
      setLicenseTypeID(""); // Vendos vlerën e ArticleID në null
    }
  };

  const defaultPropsPackageType = {
    options: pack,
    getOptionLabel: (option) => `${option.PackageName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.PackageName}
            <br />
          </span>
        </li>
      </>
    ),
  };
  // const [packageType, setPackageType] = useState(null);
  // const [packageField, setPackageField] = useState(null);
  // const handleAutocompleteChangePackageType = (event, value) => {
  //   if (value && value.PackID) {
  //     setPackageID(value.PackID);
  //     setPackageType(value.PackName);
  //     setPackageField(value);
  //   } else {
  //     // Në rast se vlera është pastruar
  //     setLicenseTypeID(""); // Vendos vlerën e ArticleID në null
  //   }
  // };

  // const defaultPropsPackageType = {
  //   options: pack,
  //   getOptionLabel: (option) => `${option.PackName}` || "",
  //   renderOption: (props, option) => (
  //     <>
  //       <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //         <span>
  //           {option.PackName}
  //           <br />
  //         </span>
  //       </li>
  //     </>
  //   ),
  // };

  //Pjesa per select input field module
  const [moduleType, setModuleType] = useState([]);
  const [moduleField, setModuleField] = useState([]);
  const handleAutocompleteChangeModuleType = (event, value) => {
    const selectedModules = Array.isArray(value) ? value : [];
    const selectedModuleCodes = selectedModules
      .map((item) => item?.ModuleCode)
      .filter(Boolean);
    const selectedModuleIds = selectedModules
      .map((item) => Number(item?.ModuleID))
      .filter((id) => Number.isInteger(id) && id > 0);

    setModuleType(selectedModuleCodes);
    setModuleIDs(selectedModuleIds);
    setModuleField(selectedModules);
  };

  const handleToggleModuleCard = (moduleId) => {
    const normalizedId = Number(moduleId);
    if (!Number.isInteger(normalizedId) || normalizedId <= 0) {
      return;
    }

    setModuleIDs((prev) => {
      const current = Array.isArray(prev) ? prev : [];
      if (current.includes(normalizedId)) {
        return current.filter((id) => id !== normalizedId);
      }
      return [...current, normalizedId];
    });

    setHasUnsavedChanges(true);
  };

  const markFormAsDirty = () => {
    if (!hasUnsavedChanges) {
      setHasUnsavedChanges(true);
    }
  };

  const navigateBackToList = () => {
    if (hasUnsavedChanges) {
      const shouldLeave = window.confirm(
        "Keni ndryshime që nuk janë ruajtur ende. Nëse vazhdoni, ato mund të humbin. A dëshironi të vazhdoni?"
      );

      if (!shouldLeave) {
        return;
      }
    }

    history.push("/configuration/company");
  };

  const handleSkipStep = (targetStep) => {
    if (loading) {
      return;
    }

    setStep(targetStep);
  };

  const defaultPropsModuleType = {
    options: module,
    getOptionLabel: (option) => `${option.ModuleName}` || "",
    renderOption: (props, option) => (
      <>
        <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
          <span>
            {option.ModuleName}
            <br />
          </span>
        </li>
      </>
    ),
  };

  // const [moduleType, setModuleType] = useState(null);
  // const [moduleField, setModuleField] = useState(null);
  // const handleAutocompleteChangeModuleType = (event, value) => {
  //   if (value && value.PackID) {
  //     setModuleID(value.PackID);
  //     setModuleType(value.PackName);
  //     setModuleField(value);
  //   } else {
  //     // Në rast se vlera është pastruar
  //     setModuleID(""); // Vendos vlerën e ArticleID në null
  //   }
  // };

  // const defaultPropsModuleType = {
  //   options: module,
  //   getOptionLabel: (option) => `${option.PackName}` || "",
  //   renderOption: (props, option) => (
  //     <>
  //       <li {...props} style={{ borderBottom: "1px solid lightgray" }}>
  //         <span>
  //           {option.PackName}
  //           <br />
  //         </span>
  //       </li>
  //     </>
  //   ),
  // };

  const handleSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    const baseData = {
      CompanyName: companyName,
      IdentificationNumber: identificationNumber,
      VATNumber: vatNumber,
      Address: adress,
      CityID: cityID,
      StateID: stateID,
      PhoneNumbers: phoneNumbers,
      EdiPass: ediPass,
      Email: email,
      Comment: comment,
      // CreatedByUser: loginEmail,
      VATDeclarant: vATDeclarant,
      FiscalYear: year,
      IsActive: isActive,
      ARBKPass: arbkPass,
      MailPass: mailPass,
      SMTPClient: smtpClient,
    };

    const stateData = isEditMode
      ? {
          ...baseData,
          CompanyID: createdCompanyID || routeCompanyId,
          ModifiedByUser: loginEmail,
        }
      : {
          ...baseData,
          SalesTypeID: 1,
        };

    const request = isEditMode
      ? axios.put(ApiLink.API_URL + "Companies", stateData, { headers })
      : axios.post(ApiLink.API_URL + "Companies/insert-company-step1", stateData, {
          headers,
        });

    request
      .then((response) => {
        if (isEditMode) {
          setLoading(false);
          setCreatedCompanyID(createdCompanyID || routeCompanyId);
          handleSuccess("Kompania u përditësua me sukses");
          setHasUnsavedChanges(false);
          setStep(2);
          return;
        }

        const insertedCompanyId = response?.data?.companyId;
        if (!insertedCompanyId) {
          setLoading(false);
          errorAlert(
            "Kompania u ruajt, por CompanyID nuk u kthye nga serveri. Ju lutem provoni përsëri."
          );
          return;
        }

        setCreatedCompanyID(insertedCompanyId);
        handleSuccess("Company Added Successfully");
        setDisableForm(true);
        setLoading(false);
        setHasUnsavedChanges(false);
        setStep(2); // Move to License Form
      })
      .catch((error) => {
        setLoading(false);
        setDisableForm(false);
        errorAlert(
          getApiErrorMessage(
            error,
            "Gabim i panjohur gjatë ruajtjes së kompanisë."
          )
        );
      });
  };

  const handleSubmitLicense = async (event) => {
    event.preventDefault();

    if (isEditMode) {
      setStep(3);
      return;
    }

    setLoading(true);

    const stateData = {
      LicenseTypeID: licenseTypeID,
      PackageID: packageID,
      StartDate: startDate,
      EndDate: endDate,
      Status: statusID,
      PaymentStatus: paymentStatusID,
      Comment: licenseComment,
    };

    axios
      .post(ApiLink.API_URL + "License/newLicense", stateData, {
        headers,
        params: {
          companyID: createdCompanyID,
          identificationNumber: identificationNumber,
        },
      })
      .then((response) => {
        handleSuccess("Licensa u gjenerua me sukses");
        setLoading(false);
        setHasUnsavedChanges(false);
        setStep(3); // Move to modules step
      })
      .catch((error) => {
        setLoading(false);
        setDisableForm(false);
        errorAlert(
          getApiErrorMessage(
            error,
            "Gabim i panjohur gjatë gjenerimit të licensës."
          )
        );
      });
  };

  const handleSubmitModules = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      await handleUpdateCompanyPack();

      if (isEditMode) {
        await loadCompanyVisibilityMenus({ force: true, showError: true });
        handleSuccess("Paketa dhe modulet u përditësuan me sukses");
        setHasUnsavedChanges(false);
        setStep((prev) => Math.max(prev, 6));
      } else if (Number(licenseTypeID) === 5) {
        setHasUnsavedChanges(false);
        setStep(4);
      } else {
        setHasUnsavedChanges(false);
        setStep(5);
      }
    } catch (error) {
      errorAlert(
        getApiErrorMessage(error, "Gabim gjatë përditësimit të pakos dhe moduleve.")
      );
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateCompanyPack = () => {
    const updateData = {
      Pack: packageType,
      PackID: packageID ? Number(packageID) : null,
      Module: Array.isArray(moduleType) ? moduleType.join(",") : moduleType,
      ModuleIds: moduleIDs,
      StartDate: startDate,
      EndDate: endDate,
    };

    // axios.put(ApiLink.API_URL + 'PackContoller', updateData, { headers })
    axios
      .put(ApiLink.API_URL + "PackContoller/packForCompany", updateData, {
        headers,
        params: {
          companyID: createdCompanyID,
          identificationNumber: identificationNumber,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          // handleSuccess(response.data); // Shfaq mesazhin e suksesit
        }
      })
      .catch((error) => {
        if (error.response) {
          if (error.response.status === 400) {
            errorAlert(
              "Të dhënat janë të pavlefshme. Ju lutem kontrolloni dhe provoni përsëri."
            );
          } else if (error.response.status === 500) {
            errorAlert("Gabim serveri. Ju lutem provoni më vonë.");
          } else {
            errorAlert("Gabim i panjohur: " + error.response.data);
          }
        } else {
          errorAlert(
            "Nuk mund të lidhemi me serverin. Ju lutem provoni më vonë."
          );
        }
        throw error;
      });
  };

  const handleSubmitAccountant = (event) => {
    event.preventDefault();

    if (isEditMode && hasExistingAccountant) {
      handleSuccess("Kontabilisti ekzistues është ngarkuar në formular.");
      setHasUnsavedChanges(false);
      setStep(5);
      return;
    }

    setLoading(true);

    const stateData = {
      UserID: accountantUserID,
      IPAddress: ipAddress,
      Comment: userComment,
    };

    axios
      .post(ApiLink.API_URL + "License/newFreeManagementAccount", stateData, {
        headers,
        params: {
          companyID: createdCompanyID,
          identificationNumber: identificationNumber,
        },
      })
      .then((response) => {
        setLoading(false);
        handleSuccess("Llogaria u shtua tek lista e kontabilistit");
        setHasUnsavedChanges(false);
        setStep(5); // Move to new user Form
      })
      .catch((error) => {
        setLoading(false);
        errorAlert(
          getApiErrorMessage(
            error,
            "Gabim i panjohur gjatë lidhjes së kontabilistit."
          )
        );
      });
  };

  const loadActiveCompanyUsers = async (companyIdValue = createdCompanyID) => {
    if (!companyIdValue) {
      setActiveCompanyUsers([]);
      return;
    }

    setCompanyUsersLoading(true);
    try {
      const response = await axios.get(
        `${ApiLink.API_URL}AuthProva/company-users/${companyIdValue}`,
        { headers }
      );
      const users = Array.isArray(response.data) ? response.data : [];
      setActiveCompanyUsers(users);
      setHasExistingCompanyUser(users.length > 0);
    } catch (error) {
      errorAlert(
        getApiErrorMessage(error, "Gabim gjatë marrjes së përdoruesve aktivë.")
      );
    } finally {
      setCompanyUsersLoading(false);
    }
  };

  const handleSubmitCompanyUser = (event) => {
    event.preventDefault();

    if (!createdCompanyID) {
      errorAlert("CompanyID mungon. Ju lutem kthehuni në hapin 1.");
      return;
    }

    if (!newUserEmail || !newUserEmail.includes("@")) {
      errorAlert("Ju lutem vendosni një email valid për përdoruesin.");
      return;
    }

    if (!editingCompanyUserId && (!newUserPassword || newUserPassword.length < 8)) {
      errorAlert("Fjalëkalimi duhet të ketë së paku 8 karaktere.");
      return;
    }

    if (!newUserRole) {
      errorAlert("Ju lutem zgjedhni rolin e përdoruesit.");
      return;
    }

    setLoading(true);

    if (editingCompanyUserId) {
      const stateData = {
        UserId: editingCompanyUserId,
        CompanyID: createdCompanyID,
        Email: newUserEmail,
        Role: newUserRole,
      };

      axios
        .put(ApiLink.API_URL + "AuthProva/company-user", stateData, {
          headers,
        })
        .then(async () => {
          setLoading(false);
          handleSuccess("Përdoruesi u përditësua me sukses");
          setHasUnsavedChanges(false);
          setEditingCompanyUserId("");
          setNewUserEmail("");
          setNewUserPassword("");
          await loadActiveCompanyUsers(createdCompanyID);
        })
        .catch((error) => {
          setLoading(false);
          errorAlert(
            getApiErrorMessage(error, "Gabim gjatë përditësimit të përdoruesit.")
          );
        });

      return;
    }

    const stateData = {
      Email: newUserEmail,
      Password: newUserPassword,
      CompanyID: createdCompanyID,
      Role: newUserRole,
    };

    axios
      .post(ApiLink.API_URL + "AuthProva/createCompanyUser", stateData, {
        headers,
      })
      .then(async () => {
        setLoading(false);
        handleSuccess("Përdoruesi u krijua me sukses");
        setHasUnsavedChanges(false);
        setNewUserEmail("");
        setNewUserPassword("");
        await loadActiveCompanyUsers(createdCompanyID);
        setStep(6);
      })
      .catch((error) => {
        setLoading(false);
        errorAlert(
          getApiErrorMessage(error, "Gabim gjatë krijimit të përdoruesit.")
        );
      });
  };

  const handleEditCompanyUser = (userItem) => {
    setEditingCompanyUserId(userItem.Id || "");
    setNewUserEmail(userItem.Email || userItem.UserName || "");
    setNewUserPassword("");
    setNewUserRole(userItem.Role || newUserRole || "");
  };

  const handleDeleteCompanyUser = async (userItem) => {
    if (!createdCompanyID || !userItem?.Id) {
      return;
    }

    const confirmDelete = window.confirm(
      `A dëshironi ta fshini përdoruesin ${userItem.Email || userItem.UserName || ""}?`
    );

    if (!confirmDelete) {
      return;
    }

    try {
      setLoading(true);
      await axios.delete(
        `${ApiLink.API_URL}AuthProva/company-user/${userItem.Id}`,
        {
          headers,
          params: { companyId: createdCompanyID },
        }
      );

      handleSuccess("Përdoruesi u fshi me sukses");
      setHasUnsavedChanges(false);
      if (editingCompanyUserId === userItem.Id) {
        setEditingCompanyUserId("");
        setNewUserEmail("");
        setNewUserPassword("");
      }
      await loadActiveCompanyUsers(createdCompanyID);
    } catch (error) {
      errorAlert(
        getApiErrorMessage(error, "Gabim gjatë fshirjes së përdoruesit.")
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!createdCompanyID || step < 5) {
      return;
    }

    loadActiveCompanyUsers(createdCompanyID);
  }, [createdCompanyID, step]);

  const updateNodeHiddenState = (nodes, menuId, isHidden) => {
    return (nodes || []).map((node) => {
      if (node.MenuID === menuId) {
        return {
          ...node,
          IsHidden: isHidden,
          Children: updateNodeHiddenState(node.Children || [], menuId, isHidden),
        };
      }

      return {
        ...node,
        Children: updateNodeHiddenState(node.Children || [], menuId, isHidden),
      };
    });
  };

  const handleToggleMenuVisibility = async (menuNode) => {
    if (!createdCompanyID || !menuNode?.MenuID) {
      return;
    }

    const nextHiddenState = !menuNode.IsHidden;
    const previousTree = companyMenuTree;
    setCompanyMenuTree((prev) =>
      updateNodeHiddenState(prev, menuNode.MenuID, nextHiddenState)
    );
    setMenuVisibilitySavingId(menuNode.MenuID);

    try {
      await axios.put(
        ApiLink.API_URL + "MenuEngine/company-visibility",
        {
          companyId: createdCompanyID,
          menuId: menuNode.MenuID,
          isHidden: nextHiddenState,
        },
        { headers }
      );
    } catch (error) {
      setCompanyMenuTree(previousTree);
      errorAlert(
        getApiErrorMessage(error, "Gabim gjatë ruajtjes së visibility së menusë.")
      );
    } finally {
      setMenuVisibilitySavingId(null);
    }
  };

  const renderVisibilityNodes = (nodes, level = 0) => {
    return (nodes || []).map((node) => {
      const isSavingCurrent = menuVisibilitySavingId === node.MenuID;
      const nodeClassName = `ncf-visibility-node ${
        node.IsHidden ? "is-hidden" : "is-visible"
      }`;
      const buttonClassName = `ncf-visibility-btn ${
        node.IsHidden ? "is-show" : "is-hide"
      }`;

      return (
        <div
          key={node.MenuID}
          className="ncf-visibility-item"
          style={{ paddingLeft: `${level * 18}px` }}
        >
          <div className={nodeClassName}>
            <div className="ncf-visibility-left">
              <span className="ncf-visibility-dot" aria-hidden="true" />
              <div className="ncf-visibility-labels">
                <span className="ncf-visibility-title">{node.Title}</span>
                <span className="ncf-visibility-subtitle">Menu ID: {node.MenuID}</span>
              </div>
              {node.IsHidden ? (
                <span className="ncf-visibility-state is-hidden">Fshehur</span>
              ) : (
                <span className="ncf-visibility-state is-visible">Shfaqet</span>
              )}
            </div>
            <button
              type="button"
              className={buttonClassName}
              disabled={isSavingCurrent}
              onClick={() => handleToggleMenuVisibility(node)}
            >
              {isSavingCurrent
                ? "Duke ruajtur..."
                : node.IsHidden
                ? "Shfaq menunë"
                : "Fsheh menunë"}
            </button>
          </div>
          {node.Children && node.Children.length > 0
            ? <div className="ncf-visibility-children">{renderVisibilityNodes(node.Children, level + 1)}</div>
            : null}
        </div>
      );
    });
  };

  const getMenuVisibilityStats = (nodes) => {
    let total = 0;
    let hidden = 0;

    const visit = (list) => {
      (list || []).forEach((node) => {
        total += 1;
        if (node.IsHidden) {
          hidden += 1;
        }
        if (node.Children && node.Children.length > 0) {
          visit(node.Children);
        }
      });
    };

    visit(nodes);
    return {
      total,
      hidden,
      visible: Math.max(total - hidden, 0),
    };
  };

  const loadCompanyVisibilityMenus = async ({
    force = false,
    showError = true,
  } = {}) => {
    if ((!force && step < 6) || !createdCompanyID || !newUserRole) {
      return;
    }

    setMenuVisibilityLoading(true);
    try {
      const response = await axios.get(
        ApiLink.API_URL + "MenuEngine/company-visibility",
        {
          headers,
          params: {
            companyId: createdCompanyID,
            role: newUserRole,
          },
        }
      );

      setCompanyMenuTree(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      if (showError) {
        errorAlert(
          getApiErrorMessage(
            error,
            "Gabim gjatë marrjes së menuve për visibility të kompanisë."
          )
        );
      }
    } finally {
      setMenuVisibilityLoading(false);
    }
  };

  useEffect(() => {
    loadCompanyVisibilityMenus();
  }, [step, createdCompanyID, newUserRole]);

  const visibilityStats = getMenuVisibilityStats(companyMenuTree);

  useEffect(() => {
    if (!isEditMode || !routeCompanyId) {
      return;
    }

    const loadEditCompanyData = async () => {
      setEditDataLoading(true);
      try {
        const response = await axios.get(
          `${ApiLink.API_URL}Companies/company-setup/${routeCompanyId}`,
          { headers }
        );

        const setup = response.data || {};
        const company = setup.Company || {};
        const license = setup.License || {};
        const accountant = setup.Accountant || {};
        const companyUser = setup.CompanyUser || {};
        const modules = Array.isArray(setup.Modules) ? setup.Modules : [];

        setCreatedCompanyID(company.CompanyID || routeCompanyId);
        setCompanyName(company.CompanyName || "");
        setIdentificationNumber(company.IdentificationNumber || "");
        setVatNumber(company.VATNumber || "");
        setAdress(company.Address || "");
        setStateID(company.StateID || "");
        setCityID(company.CityID || "");
        setPhoneNumbers(company.PhoneNumbers || "");
        setEdiPass(company.EdiPass || "");
        setArbkPass(company.ARBKPass || "");
        setMailPass(company.MailPass || "");
        setSmtpClient(company.SMTPClient || "");
        setEmail(company.Email || "");
        setComment(company.Comment || "");
        setvATDeclarant(Boolean(company.VATDeclarant));
        setIsActive(company.IsActive === null || company.IsActive === undefined ? true : Boolean(company.IsActive));
        setPackageID(company.PackID || license.PackageID || "");
        setLicenseTypeID(license.LicenseTypeID || "");
        setStartDate(
          license.StartDate
            ? new Date(license.StartDate).toISOString().slice(0, 10)
            : new Date().toISOString().slice(0, 10)
        );
        setEndDate(license.EndDate ? new Date(license.EndDate).toISOString().slice(0, 10) : "");
        setStatusID(license.Status || "");
        setPaymentStatusID(license.PaymentStatus || "");
        setLicenseComment(license.Comment || "");
        setAccountantUserID(accountant.UserID || "");
        setIpAddress(accountant.IPAddress || "");
        setUserComment(accountant.Comment || "");
        setHasExistingAccountant(Boolean(accountant.UserID));
        setNewUserEmail("");
        setNewUserPassword("");
        setNewUserRole(companyUser.RoleName || "");
        setHasExistingCompanyUser(Boolean(companyUser.Email));
        setHasExistingLicense(Boolean(license.LicenseID));

        const moduleIds = modules
          .map((item) => Number(item.ModuleID))
          .filter((item) => Number.isInteger(item) && item > 0);
        setModuleIDs(moduleIds);

        if (company.StateID) {
          fetchCityByState(company.StateID);
        }

        await loadActiveCompanyUsers(company.CompanyID || routeCompanyId);

        setStep(6);
        setHasUnsavedChanges(false);
        setExpandedPanels({
          1: false,
          2: false,
          3: false,
          4: false,
          5: false,
          6: false,
        });
      } catch (error) {
        errorAlert(
          getApiErrorMessage(error, "Gabim gjatë ngarkimit të të dhënave për editim.")
        );
      } finally {
        setEditDataLoading(false);
      }
    };

    loadEditCompanyData();
  }, [isEditMode, routeCompanyId]);

  const fetchCityByState = async (selectedStateID) => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Cities/getcitybystate",
        { headers, params: { stateid: selectedStateID } }
      );
      setCity(response.data);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };
  useEffect(() => {
    axios
      .get(ApiLink.API_URL + "states", { headers })
      .then((response) => {
        setStates(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  // const fetchPack = async () => {
  //   try {
  //     const response = await axios.get(ApiLink.API_URL + "PackContoller", {
  //       headers,
  //       params: { type: "pako" },
  //     });
  //     setPack(response.data);
  //     setLoading(false);
  //   } catch (error) {
  //     errorAlert("Gabim në kërkesë:", error);

  //     if (
  //       error.response &&
  //       error.response.data &&
  //       error.response.data.errorMessage
  //     ) {
  //       errorAlert(
  //         `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
  //       );
  //     } else if (error.message) {
  //       errorAlert(`Gabim: ${error.message}`);
  //     } else {
  //       errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //     }
  //   }
  // };

  // const fetchModule = async () => {
  //   try {
  //     const response = await axios.get(ApiLink.API_URL + "PackContoller", {
  //       headers,
  //       params: { type: "modul" },
  //     });
  //     setModule(response.data);
  //     setLoading(false);
  //   } catch (error) {
  //     errorAlert("Gabim në kërkesë:", error);

  //     if (
  //       error.response &&
  //       error.response.data &&
  //       error.response.data.errorMessage
  //     ) {
  //       errorAlert(
  //         `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
  //       );
  //     } else if (error.message) {
  //       errorAlert(`Gabim: ${error.message}`);
  //     } else {
  //       errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
  //     }
  //   }
  // };

  const fetchUser = async () => {
    try {
      const response = await axios.get(
        ApiLink.API_URL + "Users/getAccountantUser",
        { headers }
      );
      setAccountantUser(response.data);
      setLoading(false);
    } catch (error) {
      errorAlert("Gabim në kërkesë:", error);

      if (
        error.response &&
        error.response.data &&
        error.response.data.errorMessage
      ) {
        errorAlert(
          `Gabim në marrjen e të dhënave: ${error.response.data.errorMessage}`
        );
      } else if (error.message) {
        errorAlert(`Gabim: ${error.message}`);
      } else {
        errorAlert("Gabim i panjohur në kërkesë. Shih konsolën për detaje.");
      }
    }
  };

  const calculateEndDate = (durationDays) => {
    // startDate është gjithmonë data e sotme
    const start = new Date();

    // endDate = startDate + durationDays
    const end = new Date(start);
    end.setDate(start.getDate() + Number(durationDays));

    // kthe format YYYY-MM-DD
    return end.toISOString().split("T")[0];
  };

  useEffect(() => {
    if (licenseTypes.length > 0 && licenseTypeID) {
      const selected = licenseTypes.find(
        (option) => String(option.DurationTypeID) === String(licenseTypeID)
      );
      if (selected) {
        setLiceseType(selected);
      }
    }
  }, [licenseTypes, licenseTypeID]);

  useEffect(() => {
    if (pack.length > 0 && packageID) {
      const selected = pack.find(
        (option) =>
          String(option.PackageID ?? option.PackID) === String(packageID)
      );
      if (selected) {
        setPackageField(selected);
        setPackageType(selected.PackageName || selected.PackName || "");
      }
    }
  }, [pack, packageID]);

  useEffect(() => {
    if (module.length > 0 && moduleIDs.length > 0) {
      const selectedModules = module.filter((option) =>
        moduleIDs.includes(Number(option.ModuleID))
      );
      if (selectedModules.length > 0) {
        setModuleField(selectedModules);
        setModuleType(selectedModules.map((option) => option.ModuleCode).filter(Boolean));
      }
    }
  }, [module, moduleIDs]);

  useEffect(() => {
    if (states.length > 0 && stateID) {
      const selected = states.find(
        (option) => String(option.StateID) === String(stateID)
      );
      if (selected) {
        setStateName(selected);
      }
    }
  }, [states, stateID]);

  useEffect(() => {
    if (city.length > 0 && cityID) {
      const selected = city.find(
        (option) => String(option.CityID) === String(cityID)
      );
      if (selected) {
        setCityName(selected);
      }
    }
  }, [city, cityID]);

  useEffect(() => {
    if (licensesStatus.length > 0 && statusID) {
      const selected = licensesStatus.find(
        (option) => String(option.LicenseStatusID) === String(statusID)
      );
      if (selected) {
        setLiceseStatus(selected);
      }
    }
  }, [licensesStatus, statusID]);

  useEffect(() => {
    if (licensePaymentType.length > 0 && paymentStatusID) {
      const selected = licensePaymentType.find(
        (option) => String(option.PaymentStatusID) === String(paymentStatusID)
      );
      if (selected) {
        setPaymentStatus(selected);
      }
    }
  }, [licensePaymentType, paymentStatusID]);

  useEffect(() => {
    if (accountantUser.length > 0 && accountantUserID) {
      const selected = accountantUser.find(
        (option) => String(option.Id) === String(accountantUserID)
      );
      if (selected) {
        setUserName(selected);
      }
    }
  }, [accountantUser, accountantUserID]);

  // const calculateEndDate = (type) => {
  //   const today = new Date(startDate);
  //   const end = new Date(today);

  //   switch (type) {
  //     case "trial":
  //     case "weekly":
  //       end.setDate(today.getDate() + 7);
  //       break;
  //     case "monthly":
  //       end.setMonth(today.getMonth() + 1);
  //       break;
  //     case "yearly":
  //     case "accountant":
  //       end.setFullYear(today.getFullYear() + 1);
  //       break;
  //     default:
  //       end.setDate(today.getDate());
  //   }

  //   return end.toISOString().split("T")[0]; // format YYYY-MM-DD
  // };

  useEffect(() => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = String(currentDate.getMonth() + 1).padStart(2, "0");
    const day = String(currentDate.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    if (fiscalYear === year) {
      setStartDate(formattedDate);
    } else {
      setStartDate("");
    }
  }, [fiscalYear]);

  const loaddata = async () => {
    try {
      const [
        packagesType,
        modules,
        licenseType,
        licenseStatus,
        licensePaymentType,
        roleData,
      ] = await Promise.all([
        getSystemPackage(headers),
        getSystemModules(headers),
        getSystemLicenseTypes(headers),
        getLicenseStatus(headers),
        getLicensePaymentStatus(headers),
        GetSystemRoles(headers),
      ]);

      if (packagesType) setPack(packagesType);
      if (modules) setModule(modules);
      if (licenseType) setLicenseTypes(licenseType);

      console.log(licenseType);
      if (licenseStatus) setLicensesStatus(licenseStatus);
      if (licensePaymentType) setLicensePaymentType(licensePaymentType);
      if (roleData) {
        setRoles(roleData);
        if (!newUserRole && roleData.length > 0) {
          setNewUserRole(roleData[0].Name || "");
        }
      }
    } catch (error) {}
  };

  useEffect(() => {
    // fetchPack();
    fetchUser();
    loaddata();

    // fetchModule();
  }, []);

  useEffect(() => {
    if (isEditMode) {
      return;
    }

    setExpandedPanels({
      1: step === 1,
      2: step === 2,
      3: step === 3,
      4: step === 4,
      5: step === 5,
      6: step === 6,
    });
  }, [step, isEditMode]);

  const stepTitles = {
    1: "Informatat e Kompanisë",
    2: "Gjenerimi i Licensës",
    3: "Modulet e Kompanisë",
    4: "Informata të kontabilistit",
    5: "Krijo Përdorues",
    6: "Menytë e Kompanisë",
  };

  const progressPercent = ((Math.max(step, 1) - 1) / 5) * 100;

  const toggleStepPanel = (panelStep) => {
    if (panelStep > step) {
      return;
    }

    setExpandedPanels((prev) => ({
      ...prev,
      [panelStep]: !prev[panelStep],
    }));
  };

  const renderStepPanelHeader = (panelStep) => {
    const isActive = step === panelStep;
    const isCompleted = step > panelStep;
    const isOpen = !!expandedPanels[panelStep];
    const canToggle = step >= panelStep;

    return (
      <button
        type="button"
        className={`ncf-step-panel-header ${
          isActive ? "is-active" : isCompleted ? "is-completed" : ""
        }`}
        disabled={!canToggle}
        onClick={() => toggleStepPanel(panelStep)}
      >
        <div className="ncf-step-panel-header-left">
          <span className="ncf-step-panel-number">
            {isCompleted ? "✓" : panelStep}
          </span>
          <span className="ncf-step-panel-title">{stepTitles[panelStep]}</span>
        </div>
        <span
          className={`ncf-step-panel-arrow ${isOpen ? "is-open" : ""}`}
          aria-hidden="true"
        >
          ▾
        </span>
      </button>
    );
  };

  return (
    <div
      className="form-container new-company-form-unique"
      onChangeCapture={markFormAsDirty}
      onInputCapture={markFormAsDirty}
    >
      <div className="ncf-topbar">
        <div className="ncf-topbar-title-wrap">
          <h1>{isEditMode ? "Edito Kompaninë" : "Krijo Kompani të Re"}</h1>
          <p>Plotëso hapat e konfigurimit dhe ruaj të dhënat sipas nevojës.</p>
        </div>
        <button
          type="button"
          className="ncf-back-list-btn"
          onClick={navigateBackToList}
        >
          Kthehu në listë
        </button>
      </div>

      {editDataLoading ? (
        <div className="ncf-edit-loading-banner">Duke ngarkuar të dhënat e kompanisë për editim...</div>
      ) : null}

      <div className="ncf-wizard-nav-wrap">
        <div className="ncf-wizard-progress-track" aria-hidden="true">
          <span style={{ width: `${progressPercent}%` }} />
        </div>
        <div className="ncf-wizard-nav">
          {[1, 2, 3, 4, 5, 6].map((item) => (
            <div
              key={item}
              className={`ncf-wizard-nav-item ${
                step === item ? "is-active" : step > item ? "is-completed" : ""
              }`}
            >
              <div className="ncf-wizard-nav-circle">
                {step > item ? "✓" : item}
              </div>
              <span>{stepTitles[item]}</span>
            </div>
          ))}
        </div>
      </div>

      <div className="ncf-step-panels">
      {/* Step 1 */}
      <section className="ncf-step-panel">
      {renderStepPanelHeader(1)}
      {expandedPanels[1] && (
        <form className="card step1-card" onSubmit={handleSubmit}>
          <div className="step1-head">
            <span className="step1-badge">Hapi 1</span>
            <h2>Informatat e Kompanisë</h2>
            <p>Plotëso të dhënat bazë të kompanisë para gjenerimit të licensës.</p>
          </div>

          <div className="form-grid">
            <div className="step1-section">
              <h3>Të dhënat kryesore</h3>
              <div className="form-grid-fields">
                <TextField
                  className="class__Fields"
                  required
                  id="outlined-required"
                  label="Emri i Kompanisë"
                  value={companyName}
                  onChange={(event) => setCompanyName(event.target.value)}
                  autoComplete="off"
                  disabled={disableForm}
                />
              </div>
              <div className="form-grid-fields">
                <TextField
                  className="class__Fields"
                  required
                  id="outlined-required"
                  label="Numri Identifikues"
                  value={identificationNumber}
                  onChange={(event) =>
                    setIdentificationNumber(event.target.value)
                  }
                  autoComplete="off"
                  disabled={disableForm}
                />

                <TextField
                  className="class__Fields"
                  id="outlined-required"
                  label="Numri i TVSH-së"
                  value={vatNumber}
                  onChange={(event) => setVatNumber(event.target.value)}
                  autoComplete="off"
                  disabled={disableForm}
                />
              </div>
            </div>

            <div className="step1-section">
              <h3>Lokacioni</h3>
              <div className="form-grid-fields">
                <Autocomplete
                  className="class__Fields"
                  {...defaultPropsStates}
                  id="include-input-in-list"
                  includeInputInList
                  value={stateName}
                  getOptionLabel={(option) => option.StateName || ""}
                  onChange={handleAutocompleteChangeState}
                  autoComplete="off"
                  disabled={disableForm}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Zgjedh shtetin"
                      autoComplete="off"
                      disabled={disableForm}
                    />
                  )}
                />
                <Autocomplete
                  className="class__Fields"
                  {...defaultPropsCities}
                  id="include-input-in-list"
                  includeInputInList
                  value={cityName}
                  getOptionLabel={(option) => option.CityName || ""}
                  onChange={handleAutocompleteChangeCity}
                  autoComplete="off"
                  disabled={disableForm}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Zgjedh Qytetin"
                      autoComplete="off"
                      disabled={disableForm}
                    />
                  )}
                />
                <TextField
                  className="class__Fields"
                  id="outlined-required"
                  label="Adresa"
                  value={adress}
                  onChange={(event) => setAdress(event.target.value)}
                  autoComplete="off"
                  disabled={disableForm}
                />
              </div>
            </div>

            <div className="step1-section">
              <h3>Kontakti dhe SMTP</h3>
              <div className="form-grid-fields">
                <TextField
                  className="class__Fields"
                  id="outlined-required"
                  label="Numri Telefonit"
                  value={phoneNumbers}
                  onChange={(event) => setPhoneNumbers(event.target.value)}
                  autoComplete="off"
                  disabled={disableForm}
                />

                <TextField
                  className="class__Fields"
                  id="outlined-required"
                  label="Email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  autoComplete="off"
                  disabled={disableForm}
                />

                <TextField
                  className="class__Fields"
                  id="outlined-required"
                  label="SMTP Client"
                  name="SMTPClient"
                  value={smtpClient}
                  onChange={(event) => setSmtpClient(event.target.value)}
                  autoComplete="off"
                  disabled={disableForm}
                />
              </div>
            </div>

            <div className="step1-section">
              <h3>Siguria dhe parametrat</h3>
              <div className="form-grid-fields">
                <TextField
                  className="class__Fields"
                  id="outlined-required"
                  label="Fjalëkalimi i Email-it"
                  value={mailPass}
                  onChange={(event) => setMailPass(event.target.value)}
                  autoComplete="off"
                  disabled={disableForm}
                />

                <TextField
                  className="class__Fields"
                  id="outlined-required"
                  label="Fjalëkalimi i sistemit të ATK-së"
                  value={ediPass}
                  onChange={(event) => setEdiPass(event.target.value)}
                  autoComplete="off"
                  disabled={disableForm}
                />

                <TextField
                  className="class__Fields"
                  id="outlined-required"
                  label="Fjalëkalimi i sistemit të ARBK-së"
                  value={arbkPass}
                  onChange={(event) => setArbkPass(event.target.value)}
                  autoComplete="off"
                  disabled={disableForm}
                />
              </div>

              <label className="step1-description-label">
                Përshkrim
                <textarea
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  rows="2"
                  autoComplete="off"
                  disabled={disableForm}
                />
              </label>

              <div className="step1-toggle-row">
                <label className="step1-toggle-item">
                  Deklarues i TVSH-së
                  <input
                    type="checkbox"
                    checked={vATDeclarant}
                    onChange={(e) => setvATDeclarant(e.target.checked)}
                    disabled={disableForm}
                  />
                </label>
                <label className="step1-toggle-item">
                  Statusi i kompanisë
                  <input
                    type="checkbox"
                    checked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)}
                    disabled={disableForm}
                  />
                </label>
              </div>
            </div>
          </div>
          <button className="ncf-submit-btn" type="submit" disabled={loading}>
            {loading ? "Duke u procesuar" : isEditMode ? "Ruaj ndryshimet" : "Ruaj"}
          </button>
        </form>
      )}
      </section>
      {/* Step 2 */}
      <section className="ncf-step-panel">
      {renderStepPanelHeader(2)}
      {expandedPanels[2] && (
        <form className="card" onSubmit={handleSubmitLicense}>
          <h2>Hapi 2: Gjenerimi i Licensës, për kompanin: {companyName}</h2>

          <div className="form-grid">
            <Autocomplete
              className="class__Fields"
              {...defaultPropsLicenseType}
              id="include-input-in-list"
              includeInputInList
              disabled={isEditMode}
              value={licenseType}
              getOptionLabel={(option) => option.DurationName || ""}
              onChange={handleAutocompleteChangeLicenseType}
              autoComplete="off"
              // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
              renderInput={(params) => (
                <TextField
                  // style={{ width: "95%" }}
                  {...params}
                  label="Zgjedh Llojin e licenses"
                  autoComplete="off"

                  // variant="filled"
                  //   onKeyPress={handleKeyPress}
                />
              )}
            />

            <div className="form-grid-fields">
              <TextField
                className="class__Fields"
                id="date"
                type="date"
                variant="outlined"
                name="Date"
                label="Data fillimir"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
                disabled={isEditMode}
                InputLabelProps={{
                  shrink: true,
                }}
                // inputProps={{
                //     min: minDate, // Kufizimi minimal i datës
                //     max: maxDate, // Kufizimi maksimal i datës
                // }}
              />

              <TextField
                className="class__Fields"
                id="date"
                type="date"
                variant="outlined"
                name="Date"
                label="Data mbarimit"
                value={endDate}
                onChange={(e) => {
                  setEndDate(e.target.value);
                }}
                disabled={isEditMode}
                // disabled={form1IsDisabled}
                InputLabelProps={{
                  shrink: true,
                }}
                // inputProps={{
                //     min: minDate, // Kufizimi minimal i datës
                //     max: maxDate, // Kufizimi maksimal i datës
                // }}
              />
            </div>
            <div className="form-grid-fields">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsPackageType}
                id="include-input-in-list"
                includeInputInList
                value={packageField}
                getOptionLabel={(option) => option.PackageName || ""}
                onChange={handleAutocompleteChangePackageType}
                autoComplete="off"
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Zgjedh Llojin e Pakos"
                    autoComplete="off"

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />
            </div>
            <div className="form-grid-fields">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsLicenseStatus}
                id="include-input-in-list"
                includeInputInList
                disabled={isEditMode}
                // value={licenseStatus}
                value={
                  licensesStatus.find((option) => option.LicenseStatusID === statusID) ||
                  licenseStatus
                }
                getOptionLabel={(option) => option.StatusName || ""}
                onChange={handleAutocompleteChangeLicenseStatus}
                autoComplete="off"
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Statusi i licenses"
                    autoComplete="off"

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />

              <Autocomplete
                className="class__Fields"
                {...defaultPropsPaymentStatus}
                id="include-input-in-list"
                includeInputInList
                disabled={isEditMode}
                // value={paymentStatus}
                value={
                  licensePaymentType.find(
                    (option) => option.PaymentStatusID === paymentStatusID
                  ) || paymentStatus
                }
                getOptionLabel={(option) => option.StatusName || ""}
                onChange={handleAutocompleteChangePaymentStatus}
                autoComplete="off"
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Statusi i pagesës"
                    autoComplete="off"

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />
            </div>
            <label>
              Përshkrim
              <textarea
                value={licenseComment}
                onChange={(e) => setLicenseComment(e.target.value)}
                rows="2"
                disabled={isEditMode}
              />
            </label>
          </div>
          <button className="ncf-submit-btn" type="submit" disabled={loading}>
            {loading ? "Duke u procesuar..." : "Ruaj licensën dhe vazhdo"}
          </button>
        </form>
      )}
      </section>

      {/* Step 3 */}
      <section className="ncf-step-panel">
      {renderStepPanelHeader(3)}
      {expandedPanels[3] && (
        <form className="card" onSubmit={handleSubmitModules}>
          <h2>Hapi 3: Modulet e Kompanisë</h2>
          <div className="form-grid">
            <div className="ncf-modules-grid">
              {(module || []).filter((item) => Number(item?.IsExternal) !== 1).map((item) => {
                const moduleId = Number(item?.ModuleID);
                const isChecked = (moduleIDs || []).includes(moduleId);

                return (
                  <label
                    key={item?.ModuleID || item?.ModuleName}
                    className={`ncf-module-card ${isChecked ? "is-checked" : ""}`}
                  >
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={() => handleToggleModuleCard(moduleId)}
                    />
                    <span className="ncf-module-card-name">{item?.ModuleName || "Pa emër"}</span>
                  </label>
                );
              })}

              {(module || []).filter((item) => Number(item?.IsExternal) !== 1).length === 0 ? (
                <div className="ncf-modules-empty">Nuk ka module të brendshme aktive në sistem.</div>
              ) : null}
            </div>
          </div>
          <div className="ncf-actions-row">
            <button
              type="button"
              className="ncf-skip-btn"
              onClick={() => handleSkipStep(Number(licenseTypeID) === 5 ? 4 : 5)}
              disabled={loading}
            >
              Skip
            </button>
            <button className="ncf-submit-btn" type="submit" disabled={loading}>
              {loading ? "Duke u procesuar..." : "Ruaj modulet dhe vazhdo"}
            </button>
          </div>
        </form>
      )}
      </section>

      {/* Step 4 */}
      <section className="ncf-step-panel">
      {renderStepPanelHeader(4)}
      {expandedPanels[4] && (
        <form className="card" onSubmit={handleSubmitAccountant}>
          <h2>Hapi 4: Informata për kontabilistin</h2>
          <div className="form-grid">
            <div className="form-grid-fields">
              <Autocomplete
                className="class__Fields"
                {...defaultPropsUser}
                id="include-input-in-list"
                includeInputInList
                disabled={isEditMode && hasExistingAccountant}
                value={userName}
                getOptionLabel={(option) => option.UserName || ""}
                onChange={handleAutocompleteChangeUser}
                autoComplete="off"
                // isOptionEqualToValue={(option, value) => option.StateID === value.StateID} // Shto funksionin isOptionEqualToValue
                renderInput={(params) => (
                  <TextField
                    // style={{ width: "95%" }}
                    {...params}
                    label="Zgjedh përdoruesin"
                    autoComplete="off"

                    // variant="filled"
                    //   onKeyPress={handleKeyPress}
                  />
                )}
              />

              <TextField
                className="class__Fields"
                id="outlined-required"
                label="IP Adresa"
                value={ipAddress}
                onChange={(event) => setIpAddress(event.target.value)}
                autoComplete="off"
                disabled={isEditMode && hasExistingAccountant}
              />
            </div>
            <label>
              Përshkrim
              <textarea
                value={userComment}
                onChange={(e) => setUserComment(e.target.value)}
                rows="2"
                disabled={isEditMode && hasExistingAccountant}
              />
            </label>
          </div>
          <div className="ncf-actions-row">
            <button
              type="button"
              className="ncf-skip-btn"
              onClick={() => handleSkipStep(5)}
              disabled={loading}
            >
              Skip
            </button>
            <button className="ncf-submit-btn" type="submit" disabled={loading}>
              {loading ? "Duke u procesuar..." : isEditMode && hasExistingAccountant ? "Kontabilisti ekziston" : "Ruaj"}
            </button>
          </div>
        </form>
      )}
      </section>

      <section className="ncf-step-panel">
      {renderStepPanelHeader(5)}
      {expandedPanels[5] && (
        <form className="card" onSubmit={handleSubmitCompanyUser}>
          <h2>Hapi 5: Krijo përdoruesin e kompanisë</h2>

          <div className="ncf-users-list-wrap">
            <h3>Përdoruesit aktivë</h3>
            {companyUsersLoading ? (
              <div className="ncf-users-list-empty">Duke ngarkuar përdoruesit aktivë...</div>
            ) : activeCompanyUsers.length === 0 ? (
              <div className="ncf-users-list-empty">Nuk ka përdorues aktivë për këtë kompani.</div>
            ) : (
              <div className="ncf-users-list">
                {activeCompanyUsers.map((userItem) => (
                  <div key={userItem.Id} className="ncf-users-list-item">
                    <div>
                      <strong>{userItem.Email || userItem.UserName}</strong>
                      {userItem.UserName &&
                      String(userItem.UserName).trim().toLowerCase() !==
                        String(userItem.Email || "").trim().toLowerCase() ? (
                        <span>{userItem.UserName}</span>
                      ) : null}
                    </div>
                    <div className="ncf-users-item-actions">
                      <span className="ncf-users-role">{userItem.Role || "-"}</span>
                      <button
                        type="button"
                        className="ncf-user-action-btn is-edit"
                        onClick={() => handleEditCompanyUser(userItem)}
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        className="ncf-user-action-btn is-delete"
                        onClick={() => handleDeleteCompanyUser(userItem)}
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>

          <h3 className="ncf-add-user-title">
            {editingCompanyUserId ? "Modifiko përdoruesin" : "Shto përdorues të ri"}
          </h3>
          <div className="form-grid">
            <div className="form-grid-fields">
              <TextField
                className="class__Fields"
                required
                label="Email"
                value={newUserEmail}
                onChange={(event) => setNewUserEmail(event.target.value)}
                autoComplete="off"
              />

              <TextField
                className="class__Fields"
                required={!editingCompanyUserId}
                type="password"
                label={editingCompanyUserId ? "Fjalëkalimi (opsional në edit)" : "Fjalëkalimi"}
                value={newUserPassword}
                onChange={(event) => setNewUserPassword(event.target.value)}
                autoComplete="new-password"
              />

              <TextField
                className="class__Fields"
                required
                select
                SelectProps={{ native: true }}
                label="Roli"
                value={newUserRole}
                onChange={(event) => setNewUserRole(event.target.value)}
                disabled={(roles || []).length === 0}
              >
                {(roles || []).map((roleOption) => (
                  <option key={roleOption.Id} value={roleOption.Name || ""}>
                    {roleOption.Name}
                  </option>
                ))}
              </TextField>
            </div>
          </div>
          {editingCompanyUserId ? (
            <button
              type="button"
              className="ncf-cancel-edit-btn"
              onClick={() => {
                setEditingCompanyUserId("");
                setNewUserEmail("");
                setNewUserPassword("");
              }}
            >
              Anulo editimin
            </button>
          ) : null}
          <div className="ncf-actions-row">
            <button
              type="button"
              className="ncf-skip-btn"
              onClick={() => handleSkipStep(6)}
              disabled={loading}
            >
              Skip
            </button>
            <button className="ncf-submit-btn" type="submit" disabled={loading}>
              {loading
                ? "Duke u procesuar..."
                : editingCompanyUserId
                ? "Ruaj ndryshimet"
                : "Ruaj përdoruesin"}
            </button>
          </div>
        </form>
      )}
      </section>
      <section className="ncf-step-panel">
      {renderStepPanelHeader(6)}
      {expandedPanels[6] && (
        <form
          className="card ncf-visibility-card"
          onSubmit={(event) => {
            event.preventDefault();
            setHasUnsavedChanges(false);
            history.push("/configuration/company");
          }}
        >
          <div className="ncf-visibility-head">
            <h2>Hapi 6: Menaxho visibility e menuve</h2>
            <p>
              Menytë dhe nënmenytë paraqiten sipas parametrave të kompanisë
              (pako, module dhe roli: {newUserRole}). Çdo klikim ruhet menjëherë në DB.
            </p>

            <div className="ncf-visibility-metrics">
              <div className="ncf-visibility-metric">
                <span className="label">Totali</span>
                <strong>{visibilityStats.total}</strong>
              </div>
              <div className="ncf-visibility-metric is-visible">
                <span className="label">Shfaqur</span>
                <strong>{visibilityStats.visible}</strong>
              </div>
              <div className="ncf-visibility-metric is-hidden">
                <span className="label">Fshehur</span>
                <strong>{visibilityStats.hidden}</strong>
              </div>
            </div>
          </div>

          <div className="ncf-visibility-body">
            {menuVisibilityLoading ? (
              <div className="ncf-visibility-loading">Duke ngarkuar menytë e kompanisë...</div>
            ) : companyMenuTree.length === 0 ? (
              <div className="ncf-visibility-empty">Nuk ka menu të disponueshme për këto parametra.</div>
            ) : (
              renderVisibilityNodes(companyMenuTree)
            )}
          </div>

          <div className="ncf-actions-row">
            <button className="ncf-submit-btn ncf-visibility-next" type="submit" disabled={loading}>
              Përfundo
            </button>
          </div>
        </form>
      )}
      </section>
      </div>
    </div>
  );
}
